import { Blog } from '@commerce/types/blog'
import { Breadcrumbs, SEO } from '@components/common'
import { ReactNode } from 'react'

interface Props {
  blog: Blog
  children: ReactNode
}

const BlogWrapper: React.FC<Props> = (props) => {
  const { blog, children } = props
  return (
    <>
      <SEO
        title={blog.seo?.title || blog.title}
        description={blog.seo?.description || blog.title}
        openGraph={{
          type: 'website',
          title: blog.seo?.title || blog.title,
          description: blog.seo?.description || blog.title,
          images: [
            {
              url: 'https://cdn.shopify.com/s/files/1/0184/1161/8368/t/59/assets/logo.svg',
              width: '800',
              height: '600',
              alt: blog.seo?.title || blog.title,
            },
          ],
        }}
      />
      <section className="wrapper pb-10">
        <Breadcrumbs current={blog?.title} />
        <div className="mx-auto sm:px-6 md:px-8 xl:px-12 lg:max-w-5xl mt-12">
          <h1 className="text-mobileh3 lg:text-h2 text-text-dark text-center">
            Hoskings Jewellers Journal
          </h1>
          <h2 className="text-text-subdued font-normal text-center text-body1 lg:text-body1 mt-6 w-full lg:w-10/12 mx-auto">
            {blog.seo?.description}
          </h2>
        </div>
      </section>
      <div className="wrapper">{children}</div>
    </>
  )
}

export default BlogWrapper
